import { DeleteCategoryUseCase } from "./../domain/useCases/categories/deleteCategory"
import { UpdateCategoryUseCase } from "./../domain/useCases/categories/updateCategory"
import { CreateCategoryUseCase } from "./../domain/useCases/categories/createCategory"
import { CreateUserUseCase } from "./../domain/useCases/users/createUserUseCase"
import { SearchUsersUseCase } from "./../domain/useCases/users/searchUsers"
import { CreateSellerServiceUseCase } from "./../domain/useCases/sellersServices/createSellerService"
import { CreateServiceContentUseCase } from "./../domain/useCases/sellersServices/createServiceContent"
import { DeleteServiceRollbackUseCase } from "./../domain/useCases/sellersServices/deleteServiceRollback"
import { UpdateSellerServiceUseCase } from "./../domain/useCases/sellersServices/updateSellerService"
import { GetSellerServiceExcelUseCase } from "./../domain/useCases/sellersServices/getSellerServiceExcel"
import { GetUserDetailUseCase } from "../domain/useCases/users/getUserDetailUseCase"
import { UserRepositoryImpl } from "./../data/repositories/UserRepository"
import { UserRepository } from "./../domain/repositories/userRepository"
import { CountryRepository } from "./../domain/repositories/countryRepository"
import { CountryRepositoryImpl } from "./../data/repositories/CountryRepository"
import { UserService } from "./../data/services/UserService"
import { ServiceSessionService } from "../data/services/ServiceSessionService"
import { CategoryService } from "./../data/services/CategoryService"
import { CountryService } from "./../data/services/CountryService"
import { CategoryRepositoryImpl } from "./../data/repositories/CategoryRepository"
import { GetCategoriesUseCase } from "./../domain/useCases/categories/getCategories"
import { GetCategoryIconsUseCase } from "./../domain/useCases/categories/getCategoryIcons"
import { GetEnglishFieldsUseCase } from "./../domain/useCases/categories/getCategoriesEnglishFields"
import { UpdateSellerUseCase } from "./../domain/useCases/sellers/updateSeller"
import { CreateSellerUseCase } from "./../domain/useCases/sellers/createSeller"
import { GetAutoCompleteSellersUseCase } from "./../domain/useCases/sellers/autoCompleteSellers"
import { SellerServicesRepositoryImpl } from "./../data/repositories/SellerServiceRepository"
import { createContainer, asClass } from "awilix"
import { AxioshHttpManager } from "../data/network/Http"
import { HttpManager } from "../data/network/interface/HttpManager"
import { SellersService } from "../data/services/SellersService"
import { SellerServicesService } from "../data/services/SellerServicesService"
import { SellersRepositoryImpl } from "../data/repositories/SellerRepository"
import { ServiceSessionRepositoryImpl } from "../data/repositories/ServiceSessionRepository"
import { AuthRepositoryImpl } from "../data/repositories/AuthRepository"
import { VoucherRepositoryImpl } from "../data/repositories/VoucherRepository"
import { MicrositeRepositoryImpl } from "../data/repositories/MicrositeRepository"
import { SellerRepository } from "../domain/repositories/sellerRepository"
import { AuthRepository } from "../domain/repositories/AuthRepository"
import { SellerServicesRepository } from "../domain/repositories/sellerServicesRepository"
import { SellersViewModel } from "../ui/pages/sellers/SellersViewModel"
import { SellerServicesViewModel } from "../ui/pages/sellersServices/SellerServicesViewModel"
import { GetSellersUseCase } from "../domain/useCases/sellers/getSellers"
import { GetSellerServicesUseCase } from "../domain/useCases/sellersServices/getSellersServices"
import { GetSellerServiceDetailUseCase } from "../domain/useCases/sellersServices/getSellerServiceDetail"
import { UpdateSellerServiceStatusUseCase } from "../domain/useCases/sellersServices/updateSellerServiceStatus"
import { SearchSellersServicesUseCase } from "../domain/useCases/sellersServices/searchSellerServices"
import { UploadMultipleSellerServicePictureUseCase } from "../domain/useCases/sellersServices/uploadMultipleSellerServicePicturesUseCase"
import { CategoriesViewModel } from "../ui/pages/categories/CategoriesViewModel"
import { TransactionsViewModel } from "../ui/pages/transactions/TransactionsViewModel"
import { CategoryRepository } from "../domain/repositories/categoryRepository"
import { DeleteServiceSessionUseCase } from "../domain/useCases/serviceSessions/deleteSession"
import { UpdateServiceSessionUseCase } from "../domain/useCases/serviceSessions/updateSession"
import { CreateServiceSessionUseCase } from "../domain/useCases/serviceSessions/createSession"
import { ServiceSessionRepository } from "../domain/repositories/serviceSessionRepository"
import { CreateVoucherUseCase } from "../domain/useCases/vouchers/createVoucher"
import { UpdateVoucherUseCase } from "../domain/useCases/vouchers/updateVoucher"
import { DeleteVoucherUseCase } from "../domain/useCases/vouchers/deleteVoucher"
import { LoginUseCase } from "../domain/useCases/auth/signIn"
import { GoogleLoginUseCase } from "../domain/useCases/auth/googleSignIn"
import { GetVouchersUseCase } from "../domain/useCases/vouchers/getVouchers"
import { GetVoucherDetailUseCase } from "../domain/useCases/vouchers/getVoucherDetail"
import { VoucherRepository } from "../domain/repositories/voucherRepository"
import { MicrositeRepository } from "../domain/repositories/micrositeRepository"
import { VoucherService } from "../data/services/VoucherService"
import { MicrositeService } from "../data/services/MicrositeService"
import { VoucherViewModel } from "../ui/pages/vouchers/VoucherViewModel"
import { UploadVoucherPictureUseCase } from "../domain/useCases/vouchers/uploadVoucherPicture"
import { MicrositesViewModel } from "../ui/pages/microSites/MicrositesViewModel"
import { GetMicrositesUseCase } from "../domain/useCases/microsites/getMicrosites"
import { GetMicrositeDetailUseCase } from "../domain/useCases/microsites/getMicrositeDetail"
import { CreateMicrositeUseCase } from "../domain/useCases/microsites/createMicrosite"
import { UpdateMicrositeUseCase } from "../domain/useCases/microsites/updateMicrosite"
import { DeleteMicrositeUseCase } from "../domain/useCases/microsites/deleteMicrosite"
import { UploadMicrositeImageUseCase } from "../domain/useCases/microsites/uploadMicrositeImage"
import { UploadMicrositeDetailImageUseCase } from "../domain/useCases/microsites/uploadMicrositeDetailImage"
import { SignInViewModel } from "../ui/pages/signIn/SignInViewModel"
import { AuthService } from "../data/services/AuthService"
import { Translation } from "../ui/stores/TranslationStore"
import { AuthStore } from "../ui/stores/AuthStore"
import { ErrorHandler } from "../ui/error/ErrorHandler"
import { Settings } from "../ui/stores/Settings"
import { SettingsViewModel } from "../ui/pages/settings/SettingsViewModel"
import { UsersViewModel } from "../ui/pages/users/UsersViewModel"
import { GetUsersUseCase } from "../domain/useCases/users/getUsersUseCase"
import { GetCountriesUseCase } from "../domain/useCases/countries/getCountries"
import { GetCategoryDetailUseCase } from "../domain/useCases/categories/getCategoryDetail"
import { UpdateUserUseCase } from "../domain/useCases/users/updateUser/createUserUseCase"
import { DeleteMicrositeServiceUseCase } from "../domain/useCases/microsites/deleteMicrositeService"
import { TipRepository } from "../domain/repositories/tipRepository"
import { TipRepositoryImpl } from "../data/repositories/TipRepository"
import { TipService } from "../data/services/TipService"
import { TipsViewModel } from "../ui/pages/tips/TipsViewModel"
import { GetTipsUseCase } from "../domain/useCases/tips/getTips"
import { CreateTipUseCase } from "../domain/useCases/tips/createTip"
import { UpdateTipUseCase } from "../domain/useCases/tips/updateTip"
import { DeleteMicrositeTipUseCase } from "../domain/useCases/tips/deleteMicrositeTip"
import { AddCountryTipUseCase } from "../domain/useCases/tips/addCountryTip"
import { UpdateCountryTipUseCase } from "../domain/useCases/tips/updateCountryTip"
import { DeleteCountryTipUseCase } from "../domain/useCases/tips/deleteCountryTip"
import { TransactionsService } from "../data/services/TransactionsService"
import { TransactionsRepositoryImpl } from "../data/repositories/TransactionsRepository"
import { UploadTransactionsUseCase } from "../domain/useCases/transactions/uploadTransactions"
import { GetTransactionsUseCase } from "../domain/useCases/transactions/getTransactions"
import { GiftCardService } from "../data/services/GiftCardService"
import { GiftCardRepository } from "../data/repositories/GiftCardRepository"
import { GetGiftCardsUseCase } from "../domain/useCases/giftCards/getGiftCards"
import { ServiceReviewsService } from "../data/services/ServiceReviewsService"
import { ServiceReviewsRepositoryImpl } from "../data/repositories/ServiceReviewsRepository"
import { ServiceReviewsRepository } from "../domain/repositories/serviceReviewsRepository"
import { GetServiceReviewsUseCase } from "../domain/useCases/serviceReviews/getServiceReviews"
import { CreateServiceReviewUseCase } from "../domain/useCases/serviceReviews/createServiceReview"
import { UpdateServiceReviewUseCase } from "../domain/useCases/serviceReviews/updateServiceReview"
import { DeleteServiceReviewUseCase } from "../domain/useCases/serviceReviews/deleteServiceReview"
import { GetServiceReviewsUseCaseImpl } from "../domain/useCases/serviceReviews/getServiceReviews/GetServiceReviewsUseCaseImpl"
import { CreateServiceReviewUseCaseImpl } from "../domain/useCases/serviceReviews/createServiceReview/CreateServiceReviewUseCaseImpl"
import { UpdateServiceReviewUseCaseImpl } from "../domain/useCases/serviceReviews/updateServiceReview/UpdateServiceReviewUseCaseImpl"
import { DeleteServiceReviewUseCaseImpl } from "../domain/useCases/serviceReviews/deleteServiceReview/DeleteServiceReviewUseCaseImpl"
import { ServiceReviewsViewModel } from "../ui/pages/serviceReviews/ServiceReviewsViewModel"
import { GetUploadProfilePictureUrlUseCase } from "../domain/useCases/users/getUploadPictureUrl"
import { ClientFileUploadUseCase } from "../domain/useCases/upload/clientFileUpload"
import { ClientFileUploadRepositoryImpl } from "../data/repositories/ClientFileUploadRepository"
import { ClientFileUploadService } from "../data/services/ClientFileUploadService"
import { UploadTipMediaUseCase } from "../domain/useCases/tips/uploadTipMedia"
import { ImportUsersUseCase } from "../domain/useCases/users/importUsers"
import { SendUserNotificationUseCase } from "../domain/useCases/users/sendUserNotification"
import { SendUsersNotificationUseCase } from "../domain/useCases/users/sendUsersNotification"
import { SaveBannersUseCase } from "../domain/useCases/banners/saveBanners"
import { GetBannersUseCase } from "../domain/useCases/banners/getBanners"
import { BannersRepository } from "../domain/repositories/bannersRepository"
import { BannersRepositoryImpl } from "../data/repositories/BannersRepository"
import { BannerService } from "../data/services/BannerService"
import { ReportService } from "../data/services/ReportService"
import { GetAdminReportUseCase } from "../domain/useCases/reports/getAdminReport"
import { ReportsViewModel } from "../ui/pages/reports/ReportsViewModel"
import { ReportRepository } from "../domain/repositories/reportRepository"
import { ReportRepositoryImpl } from "../data/repositories/ReportRepository"
import { DownloadTransactionsUseCase } from "../domain/useCases/transactions/downloadTransactions"
import { ForgotViewModel } from "../ui/pages/forgot/ForgotViewModel"
import { ForgotPasswordUseCase } from "../domain/useCases/auth/forgot"
import { UpdateTransactionUseCase } from "../domain/useCases/transactions/updateTransaction"
import { GetVoucherRulesUseCase } from "../domain/useCases/vouchers/getVoucherRules"
import { CreateTransactionUseCase } from "../domain/useCases/transactions/createTransaction"
import { BillingViewModel } from "../ui/pages/billing/BillingViewModel"
import { BillingRepository } from "../domain/repositories/billingRepository"
import { BillingService } from "../data/services/BillingService"
import { BillingRepositoryImpl } from "../data/repositories/BillingRepository"
import { GetInvoicesUseCase } from "../domain/useCases/billing/getInvoices"
import { ExportInvoicesUseCase } from "../domain/useCases/billing/exportInvoices"
import { UpdateInvoicesStatusUseCase } from "../domain/useCases/billing/updateInvoicesStatus"
import { UpdateTransactionCreatedDateUseCase } from "../domain/useCases/billing/updateTransactions"
import { ExportInvoiceTransactionsUseCase } from "../domain/useCases/billing/exportInvoiceTransactions"
import { GetAllLandingReviewsUseCase } from "../domain/useCases/microsites/getAllLandingReviews"
import { GetLandingReviewsBySlugUseCase } from "../domain/useCases/microsites/getLandingReviewsBySlug"
import { UpdateLandingReviewsBySlugUseCase } from "../domain/useCases/microsites/updateLandingReviewsBySlug"
import { UpdateInvoiceUseCase } from "../domain/useCases/billing/updateInvoice"
import { B2BViewModel } from "../ui/pages/b2b/B2BViewModel"
import { B2BRepositoryImpl } from "../data/repositories/B2BRepository"
import { B2BRepository } from "../domain/repositories/b2bRepository"
import { B2BService } from "../data/services/B2BService"
import { GetB2BContentUseCase } from "../domain/useCases/b2b/getB2BContent"
import { UpdateB2BContentUseCase } from "../domain/useCases/b2b/updateB2BContent"
import { UpdateB2BImageUseCase } from "../domain/useCases/b2b/updateB2BImage"
import { PaymentsViewModel } from "../ui/pages/payments/PaymentsViewModel"
import { ExportInvoicePaymentsUseCase } from "../domain/useCases/billing/exportInvoicePayments"
import { DownloadSellersUseCase } from "../domain/useCases/sellers/downloadSellers"
import { GetSellerServicesBySellerIdUseCase } from "../domain/useCases/sellersServices/getSellerServicesBySellerId"
import { TournamentsViewModel } from "../ui/pages/tournaments/TournamentsViewModel"
import { TournamentMembersViewModel } from "../ui/pages/tournaments/TournamentMembersViewModel"
import { GetTournamentMembersUseCase } from "../domain/useCases/tournamentMembers/getTournamentMembers"
import { DownloadTournamentMembersUseCase } from "../domain/useCases/tournamentMembers/downloadTournamentMembers"
import { ExportTournamentUseCase } from "../domain/useCases/tournaments/exportTournament"
import { GetSurveysUseCase } from "../domain/useCases/surveys/getSurveys"
import { GetSurveySectionsUseCase } from "../domain/useCases/surveys/getSurveySections"
import { SurveyRepository } from "../domain/repositories/surveyRepository"
import { SurveyRepositoryImpl } from "../data/repositories/SurveyRepository"
import { SurveyService } from "../data/services/SurveyService"
import { CreateSurveyUseCase } from "../domain/useCases/surveys/createSurvey"
import { UpdateSurveyUseCase } from "../domain/useCases/surveys/updateSurvey"
import { DeleteSurveyUseCase } from "../domain/useCases/surveys/deleteSurvey"
import { CreateSurveySectionUseCase } from "../domain/useCases/surveys/createSurveySection"
import { UpdateSurveySectionUseCase } from "../domain/useCases/surveys/updateSurveySection"
import { DeleteSurveySectionUseCase } from "../domain/useCases/surveys/deleteSurveySection"
import { ExportSurveysUseCase } from "../domain/useCases/surveys/exportSurveys"
import { UpdateSurveyCompletionUseCase } from "../domain/useCases/surveys/updateSurveyCompletion"
import { SurveysViewModel } from "../ui/pages/surveys/SurveysViewModel"
import { ExportSurveyOptionsUseCase } from "../domain/useCases/surveys/exportSurveyOptions"
import { CompanyExcelService } from "../data/services/CompanyExcelService"
import { CompanyExcelRepositoryImpl } from "../data/repositories/CompanyExcelRepositoryImpl"
import { CompanyExcelRepository } from "../domain/repositories/CompanyExcelRepository"
import { GetCompanyExcelsUseCase } from "../domain/useCases/companyExcel/getCompanyExcels"
import { UploadCompanyExcelUseCase } from "../domain/useCases/companyExcel/uploadCompanyExcel"
import { SendCompanyExcelEmailUseCase } from "../domain/useCases/companyExcel/sendCompanyExcelEmail"
import { CompanyExcelViewModel } from "../ui/pages/companyExcel/CompanyExcelViewModel"
import { MarketplacesViewModel } from "../ui/pages/marketplaces/MarketplacesViewModel"
import { MarketplaceRepositoryImpl } from "../data/repositories/MarketplaceRepository"
import { IMarketplaceRepository } from "../domain/repositories/marketplaceRepository"

const container = createContainer()

container.register({
	// SERVICES
	ErrorHandler: asClass<ErrorHandler>(ErrorHandler).scoped(),
	HttpManager: asClass<HttpManager>(AxioshHttpManager).scoped(),
	SellersService: asClass<SellersService>(SellersService).scoped(),
	SellerServicesService: asClass<SellerServicesService>(SellerServicesService).scoped(),
	CategoryService: asClass<CategoryService>(CategoryService).scoped(),
	VoucherService: asClass<VoucherService>(VoucherService).scoped(),
	MicrositeService: asClass<MicrositeService>(MicrositeService).scoped(),
	TipService: asClass<TipService>(TipService).scoped(),
	UserService: asClass<UserService>(UserService).scoped(),
	SurveyService: asClass<SurveyService>(SurveyService).scoped(),
	AuthService: asClass<AuthService>(AuthService).scoped(),
	ServiceSessionService: asClass<ServiceSessionService>(ServiceSessionService).scoped(),
	CountryService: asClass<CountryService>(CountryService).scoped(),
	TransactionsService: asClass<TransactionsService>(TransactionsService).scoped(),
	GiftCardService: asClass<GiftCardService>(GiftCardService).scoped(),
	ClientFileUploadService: asClass<ClientFileUploadService>(ClientFileUploadService).scoped(),
	BannerService: asClass<BannerService>(BannerService).scoped(),
	ReportService: asClass<ReportService>(ReportService).scoped(),
	BillingService: asClass<BillingService>(BillingService).scoped(),
	B2BService: asClass<B2BService>(B2BService).scoped(),
	ServiceReviewsService: asClass<ServiceReviewsService>(ServiceReviewsService).scoped(),

	// RERPOSITORIES
	SellerRepository: asClass<SellerRepository>(SellersRepositoryImpl).scoped(),
	SellerServicesRepository: asClass<SellerServicesRepository>(SellerServicesRepositoryImpl).scoped(),
	CategoryRepository: asClass<CategoryRepository>(CategoryRepositoryImpl).scoped(),
	VoucherRepository: asClass<VoucherRepository>(VoucherRepositoryImpl).scoped(),
	MicrositeRepository: asClass<MicrositeRepository>(MicrositeRepositoryImpl).scoped(),
	SurveyRepository: asClass<SurveyRepository>(SurveyRepositoryImpl).scoped(),
	TipRepository: asClass<TipRepository>(TipRepositoryImpl).scoped(),
	UserRepository: asClass<UserRepository>(UserRepositoryImpl).scoped(),
	AuthRepository: asClass<AuthRepository>(AuthRepositoryImpl).scoped(),
	ServiceSessionRepository: asClass<ServiceSessionRepository>(ServiceSessionRepositoryImpl).scoped(),
	CountryRepository: asClass<CountryRepository>(CountryRepositoryImpl).scoped(),
	TransactionsRepository: asClass<TransactionsRepositoryImpl>(TransactionsRepositoryImpl).scoped(),
	GiftCardRepository: asClass<GiftCardRepository>(GiftCardRepository).scoped(),
	ClientFileUploadRepository: asClass<ClientFileUploadRepositoryImpl>(ClientFileUploadRepositoryImpl).scoped(),
	BannersRepository: asClass<BannersRepository>(BannersRepositoryImpl).scoped(),
	ReportRepository: asClass<ReportRepository>(ReportRepositoryImpl).scoped(),
	BillingRepository: asClass<BillingRepository>(BillingRepositoryImpl).scoped(),
	B2BRepository: asClass<B2BRepository>(B2BRepositoryImpl).scoped(),
	ServiceReviewsRepository: asClass<ServiceReviewsRepository>(ServiceReviewsRepositoryImpl).scoped(),
	MarketplaceRepository: asClass<IMarketplaceRepository>(MarketplaceRepositoryImpl).scoped(),

	// USE CASES
	GetSellersUseCase: asClass<GetSellersUseCase>(GetSellersUseCase).scoped(),
	CreateSellerUseCase: asClass<CreateSellerUseCase>(CreateSellerUseCase).scoped(),
	UpdateSellerUseCase: asClass<UpdateSellerUseCase>(UpdateSellerUseCase).scoped(),
	GetSellerServicesUseCase: asClass<GetSellerServicesUseCase>(GetSellerServicesUseCase).scoped(),
	GetSellerServiceDetailUseCase: asClass<GetSellerServiceDetailUseCase>(GetSellerServiceDetailUseCase).scoped(),
	UploadMultipleSellerServicePictureUseCase: asClass<UploadMultipleSellerServicePictureUseCase>(
		UploadMultipleSellerServicePictureUseCase
	).scoped(),
	GetSellerServicesBySellerIdUseCase: asClass<GetSellerServicesBySellerIdUseCase>(
		GetSellerServicesBySellerIdUseCase
	).scoped(),
	DownloadSellersUseCase: asClass<DownloadSellersUseCase>(DownloadSellersUseCase).scoped(),
	// Categories use cases
	GetCategoriesUseCase: asClass<GetCategoriesUseCase>(GetCategoriesUseCase).scoped(),
	GetCategoryIconsUseCase: asClass<GetCategoryIconsUseCase>(GetCategoryIconsUseCase).scoped(),
	GetCategoryDetailUseCase: asClass<GetCategoryDetailUseCase>(GetCategoryDetailUseCase).scoped(),
	CreateCategoryUseCase: asClass<CreateCategoryUseCase>(CreateCategoryUseCase).scoped(),
	UpdateCategoryUseCase: asClass<UpdateCategoryUseCase>(UpdateCategoryUseCase).scoped(),
	DeleteCategoryUseCase: asClass<DeleteCategoryUseCase>(DeleteCategoryUseCase).scoped(),
	GetEnglishFieldsUseCase: asClass<GetEnglishFieldsUseCase>(GetEnglishFieldsUseCase).scoped(),
	// Users use cases
	GetUserDetailUseCase: asClass<GetUserDetailUseCase>(GetUserDetailUseCase).scoped(),
	CreateUserUseCase: asClass<CreateUserUseCase>(CreateUserUseCase).scoped(),
	UpdateUserUseCase: asClass<UpdateUserUseCase>(UpdateUserUseCase).scoped(),
	SearchUsersUseCase: asClass<SearchUsersUseCase>(SearchUsersUseCase).scoped(),
	GetUsersUseCase: asClass<GetUsersUseCase>(GetUsersUseCase).scoped(),
	GetUploadProfilePictureUrlUseCase: asClass<GetUploadProfilePictureUrlUseCase>(
		GetUploadProfilePictureUrlUseCase
	).scoped(),
	ImportUsersUseCase: asClass<ImportUsersUseCase>(ImportUsersUseCase).scoped(),
	SendUserNotificationUseCase: asClass<SendUserNotificationUseCase>(SendUserNotificationUseCase).scoped(),
	SendUsersNotificationUseCase: asClass<SendUsersNotificationUseCase>(SendUsersNotificationUseCase).scoped(),
	// Sellers services use cases
	CreateSellerServiceUseCase: asClass<CreateSellerServiceUseCase>(CreateSellerServiceUseCase).scoped(),
	CreateServiceContentUseCase: asClass<CreateServiceContentUseCase>(CreateServiceContentUseCase).scoped(),
	DeleteServiceRollbackUseCase: asClass<DeleteServiceRollbackUseCase>(DeleteServiceRollbackUseCase).scoped(),
	UpdateSellerServiceUseCase: asClass<UpdateSellerServiceUseCase>(UpdateSellerServiceUseCase).scoped(),
	UpdateSellerServiceStatusUseCase: asClass<UpdateSellerServiceStatusUseCase>(
		UpdateSellerServiceStatusUseCase
	).scoped(),
	SearchSellersServicesUseCase: asClass<SearchSellersServicesUseCase>(SearchSellersServicesUseCase).scoped(),
	DeleteServiceSessionUseCase: asClass<DeleteServiceSessionUseCase>(DeleteServiceSessionUseCase).scoped(),
	UpdateServiceSessionUseCase: asClass<UpdateServiceSessionUseCase>(UpdateServiceSessionUseCase).scoped(),
	CreateServiceSessionUseCase: asClass<CreateServiceSessionUseCase>(CreateServiceSessionUseCase).scoped(),
	// Service Reviews use cases
	GetServiceReviewsUseCase: asClass<GetServiceReviewsUseCase>(GetServiceReviewsUseCaseImpl).scoped(),
	CreateServiceReviewUseCase: asClass<CreateServiceReviewUseCase>(CreateServiceReviewUseCaseImpl).scoped(),
	UpdateServiceReviewUseCase: asClass<UpdateServiceReviewUseCase>(UpdateServiceReviewUseCaseImpl).scoped(),
	DeleteServiceReviewUseCase: asClass<DeleteServiceReviewUseCase>(DeleteServiceReviewUseCaseImpl).scoped(),
	// Vouchers use cases
	GetVouchersUseCase: asClass<GetVouchersUseCase>(GetVouchersUseCase).scoped(),
	GetVoucherRulesUseCase: asClass<GetVoucherRulesUseCase>(GetVoucherRulesUseCase).scoped(),
	GetVoucherDetailUseCase: asClass<GetVoucherDetailUseCase>(GetVoucherDetailUseCase).scoped(),
	CreateVoucherUseCase: asClass<CreateVoucherUseCase>(CreateVoucherUseCase).scoped(),
	UpdateVoucherUseCase: asClass<UpdateVoucherUseCase>(UpdateVoucherUseCase).scoped(),
	DeleteVoucherUseCase: asClass<DeleteVoucherUseCase>(DeleteVoucherUseCase).scoped(),
	UploadVoucherPictureUseCase: asClass<UploadVoucherPictureUseCase>(UploadVoucherPictureUseCase).scoped(),
	ClientFileUploadUseCase: asClass<ClientFileUploadUseCase>(ClientFileUploadUseCase).scoped(),
	// Microsites use cases
	GetMicrositesUseCase: asClass<GetMicrositesUseCase>(GetMicrositesUseCase).scoped(),
	GetAutoCompleteSellersUseCase: asClass<GetAutoCompleteSellersUseCase>(GetAutoCompleteSellersUseCase).scoped(),
	GetSellerServiceExcelUseCase: asClass<GetSellerServiceExcelUseCase>(GetSellerServiceExcelUseCase).scoped(),
	GetMicrositeDetailUseCase: asClass<GetMicrositeDetailUseCase>(GetMicrositeDetailUseCase).scoped(),
	UpdateMicrositeUseCase: asClass<UpdateMicrositeUseCase>(UpdateMicrositeUseCase).scoped(),
	CreateMicrositeUseCase: asClass<CreateMicrositeUseCase>(CreateMicrositeUseCase).scoped(),
	DeleteMicrositeServiceUseCase: asClass<DeleteMicrositeServiceUseCase>(DeleteMicrositeServiceUseCase).scoped(),
	DeleteMicrositeUseCase: asClass<DeleteMicrositeUseCase>(DeleteMicrositeUseCase).scoped(),
	UploadMicrositeImageUseCase: asClass<UploadMicrositeImageUseCase>(UploadMicrositeImageUseCase).scoped(),
	UploadMicrositeDetailImageUseCase: asClass<UploadMicrositeDetailImageUseCase>(
		UploadMicrositeDetailImageUseCase
	).scoped(),
	GetSurveysUseCase: asClass<GetSurveysUseCase>(GetSurveysUseCase).scoped(),
	GetSurveySectionsUseCase: asClass<GetSurveySectionsUseCase>(GetSurveySectionsUseCase).scoped(),
	CreateSurveyUseCase: asClass<CreateSurveyUseCase>(CreateSurveyUseCase).scoped(),
	UpdateSurveyUseCase: asClass<UpdateSurveyUseCase>(UpdateSurveyUseCase).scoped(),
	DeleteSurveyUseCase: asClass<DeleteSurveyUseCase>(DeleteSurveyUseCase).scoped(),
	CreateSurveySectionUseCase: asClass<CreateSurveySectionUseCase>(CreateSurveySectionUseCase).scoped(),
	UpdateSurveySectionUseCase: asClass<UpdateSurveySectionUseCase>(UpdateSurveySectionUseCase).scoped(),
	DeleteSurveySectionUseCase: asClass<DeleteSurveySectionUseCase>(DeleteSurveySectionUseCase).scoped(),
	UpdateSurveyCompletionUseCase: asClass<UpdateSurveyCompletionUseCase>(UpdateSurveyCompletionUseCase).scoped(),
	ExportSurveysUseCase: asClass<ExportSurveysUseCase>(ExportSurveysUseCase).scoped(),
	ExportSurveyOptionsUseCase: asClass<ExportSurveyOptionsUseCase>(ExportSurveyOptionsUseCase).scoped(),
	LoginUseCase: asClass<LoginUseCase>(LoginUseCase).scoped(),
	ForgotPasswordUseCase: asClass<ForgotPasswordUseCase>(ForgotPasswordUseCase).scoped(),
	GoogleLoginUseCase: asClass<GoogleLoginUseCase>(GoogleLoginUseCase).scoped(),
	GetCountriesUseCase: asClass<GetCountriesUseCase>(GetCountriesUseCase).scoped(),
	GetAllLandingReviewsUseCase: asClass<GetAllLandingReviewsUseCase>(GetAllLandingReviewsUseCase).scoped(),
	GetLandingReviewsBySlugUseCase: asClass<GetLandingReviewsBySlugUseCase>(GetLandingReviewsBySlugUseCase).scoped(),
	UpdateLandingReviewsBySlugUseCase: asClass<UpdateLandingReviewsBySlugUseCase>(
		UpdateLandingReviewsBySlugUseCase
	).scoped(),
	// Tips use cases
	CreateTipUseCase: asClass<CreateTipUseCase>(CreateTipUseCase).scoped(),
	GetTipsUseCase: asClass<GetTipsUseCase>(GetTipsUseCase).scoped(),
	UpdateTipUseCase: asClass<UpdateTipUseCase>(UpdateTipUseCase).scoped(),
	AddCountryTipUseCase: asClass<AddCountryTipUseCase>(AddCountryTipUseCase).scoped(),
	UpdateCountryTipUseCase: asClass<UpdateCountryTipUseCase>(UpdateCountryTipUseCase).scoped(),
	DeleteCountryTipUseCase: asClass<DeleteCountryTipUseCase>(DeleteCountryTipUseCase).scoped(),
	DeleteMicrositeTipUseCase: asClass<DeleteMicrositeTipUseCase>(DeleteMicrositeTipUseCase).scoped(),
	UploadTipMediaUseCase: asClass<UploadTipMediaUseCase>(UploadTipMediaUseCase).scoped(),
	// Transactions use cases
	UploadTransactionsUseCase: asClass<UploadTransactionsUseCase>(UploadTransactionsUseCase).scoped(),
	CreateTransactionUseCase: asClass<CreateTransactionUseCase>(CreateTransactionUseCase).scoped(),
	UpdateTransactionUseCase: asClass<UpdateTransactionUseCase>(UpdateTransactionUseCase).scoped(),
	GetTransactionsUseCase: asClass<GetTransactionsUseCase>(GetTransactionsUseCase).scoped(),
	DownloadTransactionsUseCase: asClass<DownloadTransactionsUseCase>(DownloadTransactionsUseCase).scoped(),
	// Gift Cards use cases
	GetGiftCardsUseCase: asClass<GetGiftCardsUseCase>(GetGiftCardsUseCase).scoped(),
	// Banners use cases
	GetBannersUseCase: asClass<GetBannersUseCase>(GetBannersUseCase).scoped(),
	SaveBannersUseCase: asClass<SaveBannersUseCase>(SaveBannersUseCase).scoped(),
	//Reports use cases
	GetAdminReportUseCase: asClass<GetAdminReportUseCase>(GetAdminReportUseCase).scoped(),
	//Billing use cases
	GetInvoicesUseCase: asClass<GetInvoicesUseCase>(GetInvoicesUseCase).scoped(),
	ExportInvoicesUseCase: asClass<ExportInvoicesUseCase>(ExportInvoicesUseCase).scoped(),
	ExportInvoicePaymentsUseCase: asClass<ExportInvoicePaymentsUseCase>(ExportInvoicePaymentsUseCase).scoped(),
	ExportInvoiceTransactionsUseCase: asClass<ExportInvoiceTransactionsUseCase>(
		ExportInvoiceTransactionsUseCase
	).scoped(),
	UpdateInvoicesStatusUseCase: asClass<UpdateInvoicesStatusUseCase>(UpdateInvoicesStatusUseCase).scoped(),
	UpdateTransactionCreatedDateUseCase: asClass<UpdateTransactionCreatedDateUseCase>(
		UpdateTransactionCreatedDateUseCase
	).scoped(),
	UpdateInvoiceUseCase: asClass<UpdateInvoiceUseCase>(UpdateInvoiceUseCase).scoped(),
	// B2B use cases
	GetB2BContentUseCase: asClass<GetB2BContentUseCase>(GetB2BContentUseCase).scoped(),
	UpdateB2BContentUseCase: asClass<UpdateB2BContentUseCase>(UpdateB2BContentUseCase).scoped(),
	UpdateB2BImageUseCase: asClass<UpdateB2BImageUseCase>(UpdateB2BImageUseCase).scoped(),
	// Tournament members use cases
	GetTournamentMembersUseCase: asClass<GetTournamentMembersUseCase>(GetTournamentMembersUseCase).scoped(),
	DownloadTournamentMembersUseCase: asClass<DownloadTournamentMembersUseCase>(
		DownloadTournamentMembersUseCase
	).scoped(),
	// Tournament use cases
	ExportTournamentUseCase: asClass<ExportTournamentUseCase>(ExportTournamentUseCase).scoped(),
	// VIEW MODELS
	SellersViewModel: asClass<SellersViewModel>(SellersViewModel).singleton(),
	SellerServicesViewModel: asClass<SellerServicesViewModel>(SellerServicesViewModel).singleton(),
	ServiceReviewsViewModel: asClass<ServiceReviewsViewModel>(ServiceReviewsViewModel).singleton(),
	CategoriesViewModel: asClass<CategoriesViewModel>(CategoriesViewModel).singleton(),
	VoucherViewModel: asClass<VoucherViewModel>(VoucherViewModel).singleton(),
	MicrositesViewModel: asClass<MicrositesViewModel>(MicrositesViewModel).singleton(),
	TipsViewModel: asClass<TipsViewModel>(TipsViewModel).singleton(),
	SignInViewModel: asClass<SignInViewModel>(SignInViewModel).singleton(),
	ForgotViewModel: asClass<ForgotViewModel>(ForgotViewModel).singleton(),
	SettingsViewModel: asClass<SettingsViewModel>(SettingsViewModel).singleton(),
	UsersViewModel: asClass<UsersViewModel>(UsersViewModel).singleton(),
	TransactionsViewModel: asClass<TransactionsViewModel>(TransactionsViewModel).singleton(),
	ReportsViewModel: asClass<ReportsViewModel>(ReportsViewModel).singleton(),
	BillingViewModel: asClass<BillingViewModel>(BillingViewModel).singleton(),
	PaymentsViewModel: asClass<PaymentsViewModel>(PaymentsViewModel).singleton(),
	SurveysViewModel: asClass<SurveysViewModel>(SurveysViewModel).singleton(),
	B2BViewModel: asClass<B2BViewModel>(B2BViewModel).singleton(),
	TournamentsViewModel: asClass<TournamentsViewModel>(TournamentsViewModel).singleton(),
	TournamentMembersViewModel: asClass<TournamentMembersViewModel>(TournamentMembersViewModel).singleton(),
	CompanyExcelViewModel: asClass<CompanyExcelViewModel>(CompanyExcelViewModel).singleton(),
	MarketplacesViewModel: asClass<MarketplacesViewModel>(MarketplacesViewModel).singleton(),

	// Services
	CompanyExcelService: asClass<CompanyExcelService>(CompanyExcelService).singleton(),

	// Repositories
	CompanyExcelRepository: asClass<CompanyExcelRepositoryImpl>(CompanyExcelRepositoryImpl).singleton(),

	// Use Cases
	GetCompanyExcelsUseCase: asClass<GetCompanyExcelsUseCase>(GetCompanyExcelsUseCase).singleton(),
	UploadCompanyExcelUseCase: asClass<UploadCompanyExcelUseCase>(UploadCompanyExcelUseCase).singleton(),
	SendCompanyExcelEmailUseCase: asClass<SendCompanyExcelEmailUseCase>(SendCompanyExcelEmailUseCase).singleton(),

	// STORES
	AuthStore: asClass<AuthStore>(AuthStore).singleton(),
	Translation: asClass<Translation>(Translation).singleton(),
	Settings: asClass<Settings>(Settings).singleton()
})
type HttpManagerType = "HttpManager"
type ServicesType =
	| "SellersService"
	| "SellerServicesService"
	| "CategoryService"
	| "UserService"
	| "VoucherService"
	| "ClientFileUploadService"
	| "ReportService"
	| "CountryService"
	| "BillingService"
	| "B2BService"
	| "SurveyService"
type RepositoriesType =
	| "SellerRepository"
	| "SellerServicesRepository"
	| "CategoryRepository"
	| "UserRepository"
	| "VoucherRepository"
	| "ClientFileUploadRepository"
	| "ReportRepository"
	| "BillingRepository"
	| "B2BRepository"
	| "SurveyRepository"
	| "MarketplaceRepository"
type UseCasesType =
	| "GetSellersUseCase"
	| "CreateSellerUseCase"
	| "UpdateSellerUseCase"
	| "GetSellersServicesUseCase"
	| "GetCategoriesUseCase"
	| "GetCategoryIconsUseCase"
	| "GetCategoryDetailUseCase"
	| "GetUserDetailUseCase"
	| "CreateUserUseCase"
	| "SearchUsersUseCase"
	| "CreateSellerServiceUseCase"
	| "CreateServiceContentUseCase"
	| "DeleteServiceRollbackUseCase"
	| "GetAutoCompleteSellersUseCase"
	| "GetBannersUseCase"
	| "SaveBannersUseCase"
	| "GetInvoicesUseCase"
	| "GetTournamentMembersUseCase"
	| "DownloadTournamentMembersUseCase"
	| "ExportTournamentUseCase"
	| "GetSurveysUseCase"
	| "GetSurveySectionsUseCase"
	| "CreateSurveyUseCase"
	| "UpdateSurveyUseCase"
	| "DeleteSurveyUseCase"
	| "CreateSurveySectionUseCase"
	| "UpdateSurveySectionUseCase"
	| "DeleteSurveySectionUseCase"
	| "UpdateSurveyCompletionUseCase"
	| "ExportSurveysUseCase"
	| "ExportSurveyOptionsUseCase"
	| "GetMicrositesUseCase"
	| "GetLandingReviewsBySlugUseCase"
	| "UpdateLandingReviewsBySlugUseCase"
type ViewModelsType =
	| "SellersViewModel"
	| "SellerServicesViewModel"
	| "ServiceReviewsViewModel"
	| "CategoriesViewModel"
	| "VoucherViewModel"
	| "MicrositesViewModel"
	| "TipsViewModel"
	| "SignInViewModel"
	| "ForgotViewModel"
	| "SettingsViewModel"
	| "UsersViewModel"
	| "TransactionsViewModel"
	| "ReportsViewModel"
	| "BillingViewModel"
	| "B2BViewModel"
	| "PaymentsViewModel"
	| "TournamentsViewModel"
	| "TournamentMembersViewModel"
	| "SurveysViewModel"
	| "CompanyExcelViewModel"
	| "MarketplacesViewModel"
type Store = "AuthStore" | "Translation" | "Settings"
type ErrorHandlerType = "ErrorHandler"
export type ContainerType =
	| HttpManagerType
	| ServicesType
	| RepositoriesType
	| UseCasesType
	| ViewModelsType
	| Store
	| ErrorHandlerType

export { container }
